import ecran from '../../../../../core/injectors/ecran.injector';

export default ecran({
    source: 'mc1012',
    ecrans: ['00-2'],
    params: ['doccleintref']
});